import { apiClient } from './apiClient.js'

/****************************************************************************
 * 
 * Profiles
 * 
 ***************************************************************************/
export const profileApi = {
    /**
     * Fetch Component Profile Schema for a given UTG Version
     * @param {string} utgVersion - The UTG Version
     * @returns {Promise} - The Config Schema as a Promise
     */
    /*fetchComponentProfileSchema: async (utgVersion) => {
        return apiClient(
            `https://in4mapi.cctest-s4.com/in4m/api/profileschemas?componentversion=${utgVersion}`,
            null,
            {
                method: 'GET'
            }
        )
    },*/
    /**
     * Create New Profile
     * @param {string} businessEntityId - The Business Entity ID
     * @param {string} profileId - The Profile ID
     * @param {object} profileConfig - The updated profile config to send to the database
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The update result as a Promise
     */
    createProfile: async (businessEntityId, profileConfig, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/componentProfiles`
        // IMPORTANT: Note that this is PUT rather than POST.
        return await apiClient(url, accessToken, {
            method: "POST",
            body: JSON.stringify(profileConfig)
        })
    },
    /**
     * Fetch Component Profiles for a given Business Entity ID
     * @param {string} businessEntityId - The Business Entity ID
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The Component Profiles as a Promise
     */
    fetchProfileList: async (businessEntityId, config, accessToken, includeChildren = false) => {
        const baseUrl = `${config.managementApiUrl}/businessentities/${businessEntityId}/componentProfiles`
        const url = includeChildren ? `${baseUrl}?includeChildAccounts=true` : baseUrl
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (result) => {
                        return result.componentProfile
                    }
                )
            }
        )
    },
    /**
     * Fetch Component Profiles for a given Business Entity ID and profile ID
     * @param {string} businessEntityId - The Business Entity ID
     * @param {string} profileId - The Profile ID
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The Component Profile as a Promise
     * api/businessentities/{businessEntityId}/componentProfiles/{profileId}
     */
    fetchProfile: async (businessEntityId, profileId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/componentProfiles/${profileId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        return rt.componentProfile
                    }
                )
            }
        )
    },
    /**
     * Update Profile Config
     * @param {string} businessEntityId - The Business Entity ID
     * @param {string} profileId - The Profile ID
     * @param {object} profileConfig - The updated profile config to send to the database
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The update result as a Promise
     */
    updateProfile: async (businessEntityId, profileId, profileConfig, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/componentProfiles/${profileId}`
        // IMPORTANT: Note that this is PUT rather than POST.
        return await apiClient(url, accessToken, {
            method: "PUT",
            body: JSON.stringify(profileConfig)
        })
    },
    /**
     * Delete Profile
     * @param {string} businessEntityId - The Business Entity ID
     * @param {string} profileId - The Profile ID
     * @param {string} name - The Profile Name
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The update result as a Promise
     */
    deleteProfile: async (businessEntityId, profileId, name, config, accessToken) => {
        name = encodeURIComponent(name)
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/componentprofiles/${profileId}?profilename=${name}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "DELETE",
                headers: {
                    'X-HTTP-Method-Override': 'DELETE'
                }
            },
            null
        )
    },
    /**
     * Apply Profile
     * @param {string} businessEntityId - The Business Entity ID
     * @param {string} profileId - The Profile ID
     * @param {array} componentIds - An array of Component IDs
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The update result as a Promise
     */
    applyProfile: async (businessEntityId, profileId, componentIds, config, accessToken) => {
        const url = `${config.managementApiUrl}/componentProfileAssignments?installationtype=30`
        // The body is a JSON string containing an array of component profile assignment parameters. It is sent as POST with override of PATCH
        // installationtype=30 indicates that these are existing installations
        let data = []
        componentIds.forEach(id => {
            data.push({
                componentId: id,
                componentBusinessEntityId: businessEntityId,
                profileId: profileId,
                profileBusinessEntityId: businessEntityId
            })
        })
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                headers: {
                    'X-HTTP-Method-Override': 'PATCH'
                },
                body: JSON.stringify(data)
            },
            (response) => {
                return response
            }
        )
    }
}